import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/contact-1.png'


const _withScopeId = n => (_pushScopeId("data-v-0b943fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-us" }
const _hoisted_2 = {
  key: 0,
  class: "contact-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contact-dec" }, " 别让这扇无形的门阻挡您探索的脚步我们热忱期盼与您建立紧密联系！ "),
  /*#__PURE__*/_createElementVNode("div", { class: "contact-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_4 = { class: "c-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "没有账号?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-way contact-way-1" }, "您可拨打电话0551-62220000", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-way contact-way-2" }, " 或留下您的联系方式，我们将尽快派专人给您回复 ", -1))
const _hoisted_8 = { class: "submit-btn" }
const _hoisted_9 = {
  key: 1,
  class: "submitted-container"
}
const _hoisted_10 = { class: "submitted-container-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "尊敬的用户，非常感谢您提交联系方式！", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "我们已成功接收您的信息，这是您与"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "优质采招标采购平台"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "深度合作的起点。")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"20px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "接下来会有专业团队 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "依据您感兴趣的内容"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "，在 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "1-2个工作日内"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "与您取得联系，竭诚助力您开启便捷高效的招投标之旅。 ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"20px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "敬请保持通讯畅通，再次感谢您的信任!")
], -1))
const _hoisted_15 = { class: "close-btn" }

import { CheckCircleFilled } from "@ant-design/icons-vue";
import { reactive, shallowRef, watch, ref } from "vue";
import { submitContactInfo } from "@/api/site-home";
import { errorInfoDis } from "@/utils/project-utils";
import { isPhone } from "@/utils/validate";
import type { Rule } from "ant-design-vue/es/form";

interface FormState {
  name: string;
  contactWay: number | undefined;
  concerned: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'contact-us',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:visible", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
};



const rules: Record<string, Rule[]> = {
  name: [
    {
      required: true,
      message: "请输入您的姓名",
      type: "string",
      trigger: "blur",
    },
  ],
  contactWay: [
    {
      required: true,
      validator: isPhone,
      type: "number",
      trigger: "blur",
    },
  ],
};
const formRef = ref<any>();
const loading = ref<boolean>(false);
const formState = reactive<FormState>({
  name: "",
  contactWay: undefined,
  concerned: [],
});

const updateVisible = (value: boolean) => {
  emits("update:visible", value);
};

const isSubmitted = shallowRef(false);
const submitInfo = async () => {
  if (!formRef.value) {
    return;
  }
  try {
    loading.value = true;
    await formRef.value.validate();
    await submitContactInfo({
      ...formState,
      concerned: formState.concerned + "",
    });
    isSubmitted.value = true;
    loading.value = false;
    return;
  } catch (error: any) {
    loading.value = false;
    errorInfoDis(error.message || "提交失败");
    return;
  }
};
watch(
  () => props.visible,
  (value) => {
    if (value) {
      formRef.value?.resetFields();
      formState.name = "";
      formState.contactWay = undefined;
      formState.concerned = [];
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      width: "1023px",
      visible: __props.visible,
      "mask-closable": false,
      keyboard: false,
      footer: null,
      "onUpdate:visible": updateVisible
    }, {
      default: _withCtx(() => [
        (!_unref(isSubmitted))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _createVNode(_component_a_form, {
                  model: formState,
                  rules: rules,
                  "label-col": { span: 7 },
                  "wrapper-col": { span: 17 },
                  autocomplete: "off",
                  labelAlign: "left",
                  ref_key: "formRef",
                  ref: formRef
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "联系人姓名",
                      name: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          autocomplete: "off",
                          style: {"height":"52px","border-radius":"8px"},
                          value: formState.name,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.name) = $event)),
                          valueModifiers: { trim: true }
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "联系方式",
                      name: "contactWay"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          "allow-clear": "",
                          value: formState.contactWay,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.contactWay) = $event)),
                          valueModifiers: { trim: true },
                          autocomplete: "off",
                          style: {"width":"100%","height":"52px","border-radius":"8px"}
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "您感兴趣的",
                      name: "concerned"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: formState.concerned,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.concerned) = $event)),
                          mode: "multiple"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "招标采购" }, {
                              default: _withCtx(() => [
                                _createTextVNode("招标采购")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "政府采购" }, {
                              default: _withCtx(() => [
                                _createTextVNode("政府采购")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "寻源快采" }, {
                              default: _withCtx(() => [
                                _createTextVNode("寻源快采")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "供应商库管理" }, {
                              default: _withCtx(() => [
                                _createTextVNode("供应商库管理")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "询价" }, {
                              default: _withCtx(() => [
                                _createTextVNode("询价")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "竞价" }, {
                              default: _withCtx(() => [
                                _createTextVNode("竞价")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "专家库" }, {
                              default: _withCtx(() => [
                                _createTextVNode("专家库")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    onClick: _cache[3] || (_cache[3] = () => submitInfo()),
                    loading: loading.value,
                    type: "primary",
                    style: {"width":"360px","height":"60px","border-radius":"8px","font-size":"20px","font-weight":"600"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 提交 ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(CheckCircleFilled)),
                _hoisted_11
              ]),
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (updateVisible(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("关闭")
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})